import React from "react";
import { FieldArray } from "formik";
import { Reorder } from "framer-motion";
import max from "lodash-es/max";

import Alert from "@mui/material/Alert";
import Stack from "@mui/material/Stack";
import IconButton from "ui/IconButton";
import SectionDescription from "components/SectionDescription";

import useGradientSection from "hooks/dialogs/appCustomizations/leftSide/useGradientSection";

import AddIcon from "assets/svg/add.svg";
import GradientIcon from "assets/svg/gradient.svg";
import GradientRow from "./GradientRow";

const GradientSection = () => {
  const { gradients, primary, name, onChangeOrder, order } =
    useGradientSection();

  const onAddGradient = (arrayHelpers) => {
    const lastIndex = max(order);
    arrayHelpers.push(gradients.at(lastIndex) ?? primary);
    onChangeOrder(order.length ? lastIndex + 1 : 0);
  };

  const renderAddColorButton = (arrayHelpers) => {
    return (
      <IconButton
        id="add-gradient-button"
        variant="header"
        onClick={() => onAddGradient(arrayHelpers)}
      >
        <AddIcon width="20px" />
      </IconButton>
    );
  };
  return (
    <FieldArray
      name={name}
      render={(arrayHelpers) => (
        <Stack gap="16px">
          <SectionDescription
            title="Gradient"
            description="Create a smooth color transition by selecting two or more colors. The gradient will be used as the main style for your theme."
            LeadIcon={GradientIcon}
            TrailComponent={() => renderAddColorButton(arrayHelpers)}
          />
          {order.length ? (
            <Reorder.Group
              onReorder={onChangeOrder}
              values={order}
              style={{
                paddingInlineStart: 0,
                display: "flex",
                flexDirection: "column",
                gap: "16px",
              }}
            >
              {order.map((id, index) => (
                <GradientRow
                  key={`gradient-row-${id}`}
                  name={name}
                  orderId={id}
                  index={index}
                  onChangeOrder={onChangeOrder}
                />
              ))}
            </Reorder.Group>
          ) : (
            <Alert severity="warning">
              At least one color must be selected
            </Alert>
          )}
        </Stack>
      )}
    />
  );
};

export default GradientSection;
